import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { LocalNavigation } from '2-feature/Navgation/LocalNavigation';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { UI_HeaderCard } from 'ui/components/2-molecules/Card/HeaderCard/HeaderCard';
import { UI_ArticleAuthor } from 'ui/components/2-molecules/Article/ArticleAuthor/ArticleAuthor';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { ContactOffices } from '2-feature/Content/ContactOffices';

interface Props extends Content.Page {
	properties: Content.ContentPageProperties;
}

export const ContentPage = (props: Props) => {
	const { properties } = props;
	const { pageSections, heading, teaser, contactOffices } = properties ?? {};
	const dictionary = useDictionaryContext();
	return (
		<MainRegion header={<UI_HeaderCard heading={heading} teaser={teaser} reducedSpacing />} localNavigation={<LocalNavigation />}>
			{pageSections.map((sectionModule, index) => (
				<DynamicModule key={index} module={sectionModule} />
			))}
			{properties.author && <UI_ArticleAuthor {...properties.author} showOnlyName writtenBy={dictionary.getLabel('WrittenBy')} />}
			<GoToTopNavigation />
			<ContactOffices contactOffices={contactOffices} />
		</MainRegion>
	);
};
